module.exports = __webpack_public_path__ + "static/seo-analysis-7a82b272d814a25050da6561799db66d.png";